var map = {
	"./afb-color.svg": 648,
	"./alb-color.svg": 649,
	"./all.svg": 650,
	"./amb-color.svg": 651,
	"./arg.svg": 652,
	"./aus.svg": 653,
	"./bank-icon.svg": 654,
	"./bankdemo-color.svg": 655,
	"./bel.svg": 656,
	"./bimb-color.svg": 657,
	"./bkr-color.svg": 658,
	"./bpay-color.svg": 659,
	"./bra.svg": 660,
	"./bsn-color.svg": 661,
	"./can.svg": 662,
	"./checked-white.png": 663,
	"./cimb-color.svg": 664,
	"./cimb-icon.svg": 665,
	"./citi-color.svg": 666,
	"./cmr.svg": 667,
	"./crc.svg": 668,
	"./cro.svg": 669,
	"./den.svg": 670,
	"./ecu.svg": 671,
	"./eng.svg": 672,
	"./esp.svg": 673,
	"./esports-active-m.svg": 674,
	"./esports-m.svg": 675,
	"./fav-gray.png": 676,
	"./fav-icon-active.png": 677,
	"./fav-icon.png": 678,
	"./fav-red.png": 679,
	"./fra.svg": 680,
	"./game-icon.svg": 681,
	"./games-active-m.svg": 682,
	"./games-m.svg": 683,
	"./ger.svg": 684,
	"./gha.svg": 685,
	"./gxbank-color.svg": 686,
	"./hlb-color.svg": 687,
	"./hlb-icon.svg": 688,
	"./hsbc-color.svg": 689,
	"./irn.svg": 690,
	"./jpn.svg": 691,
	"./kor.svg": 692,
	"./ksa.svg": 693,
	"./kwh-color.svg": 694,
	"./latest-icon-active.png": 695,
	"./latest-icon.png": 696,
	"./lc-active-m.svg": 697,
	"./lc-icon.svg": 698,
	"./lc-m.svg": 699,
	"./lottery-active-m.svg": 700,
	"./lottery-icon.svg": 701,
	"./lottery-m.svg": 702,
	"./love.svg": 703,
	"./mar.svg": 704,
	"./mbb-color.svg": 705,
	"./mex.svg": 706,
	"./ned.svg": 707,
	"./ocbc-color.svg": 708,
	"./ocbc-icon.svg": 709,
	"./p2p-active-m.svg": 710,
	"./p2p-icon.svg": 711,
	"./p2p-m.svg": 712,
	"./pbb-color.svg": 713,
	"./pol.svg": 714,
	"./por.svg": 715,
	"./price-high.svg": 716,
	"./price-low.svg": 717,
	"./qat.svg": 718,
	"./rhb-color.svg": 719,
	"./rhb-icon.svg": 720,
	"./scb-color.svg": 721,
	"./sen.svg": 722,
	"./slot-active-m.svg": 723,
	"./slot-icon.svg": 724,
	"./slot-m.svg": 725,
	"./speed-active-m.svg": 726,
	"./speed-m.svg": 727,
	"./sport-active-m.svg": 728,
	"./sport-m.svg": 729,
	"./sports-icon.svg": 730,
	"./square-icon.svg": 731,
	"./srb.svg": 732,
	"./star.svg": 733,
	"./sui.svg": 734,
	"./tng-color.svg": 735,
	"./trx-icon.svg": 736,
	"./trx.svg": 737,
	"./tun.svg": 738,
	"./uefa-icon.svg": 739,
	"./uob-color.svg": 740,
	"./uru.svg": 741,
	"./usa.svg": 742,
	"./usdc.svg": 743,
	"./usdt.svg": 744,
	"./ustd-icon.svg": 745,
	"./wal.svg": 746,
	"./x33-logo-b.svg": 747,
	"./x33-square-icon.svg": 748
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1673;